import { ref, watch } from 'vue'
import { gradeApi } from '@/api'

const standardExamTypes = [
  'monthly_1', 'midterm', 'monthly_2', 'final',
  'mock_1', 'mock_2', 'mock_3',
  'monthly_3', 'diagnostic', 'joint_mock'
]

export function useExamTypes(semesterIdRef) {
  const dynamicExamTypes = ref([])

  const fetchExamTypes = async (semesterId) => {
    if (!semesterId) {
      dynamicExamTypes.value = []
      return
    }
    try {
      const res = await gradeApi.getExamTypes(semesterId)
      const types = res.exam_types || []
      dynamicExamTypes.value = types.filter(t => !standardExamTypes.includes(t))
    } catch (e) {
      console.error('Failed to fetch exam types:', e)
    }
  }

  watch(() => semesterIdRef.value, (newVal) => {
    fetchExamTypes(newVal)
  }, { immediate: true })

  return { dynamicExamTypes, fetchExamTypes }
}
